import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";

export default function Index({ categories }) {
  const { t } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});
  const chartRef = useRef(null);

  useEffect(() => {
    if (categories?.length) {
      const parityData = {
        datasets: [
          {
            data: categories?.map((item) => item.count) || [],
            backgroundColor: categories?.map((item) => item.backgroundColor),
            hoverOffset: 4
          }
        ],
        labels: categories.map(({_id, count, percentValue }) => `${_id} : ${count} (${percentValue}%)`),
      };

      setGraphData(parityData);
    }
  }, [categories]);

  const translatedLegends = categories
    ?.map(({ _id, backgroundColor }) => ({
      name: t(_id)+" "+t("ans"),
      backgroundColor
    }))

  const customOptions = {
    tooltips: {
      enabled:false,
      custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
    },
  };

  return (
    <Graph
        graphData={graphData}
        legends={translatedLegends}
        title={t("Catégories d’âge")}
        spaceLegende="arh-space-y-2"
        customOptions={customOptions}
        chartRef={chartRef} 
    />
  );
}
